<template v-slot:content>
    <div v-if="!loading">

        <div>
            <section class="col-12 p-0">
                <b-container>
                    <ContentOrLoading>
                        <Stepper
                            v-if="!loading"
                            ref="stepper"
                            :steps="steps"
                        >
                            <template #pasoZona="{ changeStep }">
                                <PasoUno  :compraFinalizada="compraFinalizada" @terminado="zona => { finalizarPasoUno(zona); changeStep(); }" />  
                            </template>
                            <template #pasoParcelas="{ changeStep }">
                                <PasoDos :compraFinalizada="compraFinalizada" ref="VentaPasoDos" :zona="zona" @terminado="(datos) => { rellenarDatosParcelas(datos); }" @cambiarZona="() => { cambiarZona(); changeStep(true); }" @resetDatosParcelas="datosParcelas = null" />
                            </template>
                        </Stepper>
                        <div v-if="datos_de_compradores && datosParcelas" class="col-12 mt-4 p-0" id="asignar-parcelas">
                            <h4 class="mb-3">Asignar parcelas a abonados</h4>

                            <div v-for="(abono) in abonosComprados" :key="abono.id" class="card pt-3 pb-3 d-flex flex-md-row">
                                <div class="row-12 col-md-4">

                                    <div class="mb-2">
                                        <div class="mb-1">
                                            <i class="fas fa-user mr-1"></i>
                                            <strong>{{ abono.nombre }} {{ abono.apellidos }}</strong>
                                        </div>
                                        <div>
                                            <i class="fas fa-envelope mr-1"></i>
                                            <small class="text-muted">{{ abono.email }}</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-8">
                                    <label class="form-label">Seleccionar parcelas:</label>
                                    <multiselect
                                        v-model="abono.parcelasAsignadas"
                                        placeholder="Selecciona parcelas"
                                        :custom-label="customLabelParcela"
                                        label="numero"
                                        track-by="id"
                                        :options="parcelasDisponiblesParaAbono(abono)"
                                        :multiple="true"
                                        :show-labels="false"
                                        :disabled="compraFinalizada"
                                    />
                                </div> 
                            </div>
                            <Button v-if="todasParcelasAsignadas()" @click="finalizarCompra" :disabled="compraFinalizada">Continuar</Button>
                        </div>
                    </ContentOrLoading>
                </b-container>
            </section>
        </div>
    </div>
</template>

<script>
    import PasoUno from '@/components/backend/stepper/abonos/components/ventaParcelas/PasoUno.vue';
    import PasoDos from '@/components/backend/stepper/abonos/components/ventaParcelas/PasoDos.vue';
    import Stepper from '@/components/frontend/events/compra/components/Stepper';

    export default {
        props: {
            datos_compradores: {
                type: Object,
                required: true
            },
            session_butaca_data: {
                type: Array,
                required: true
            },
            session_id: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                zona: null,
                loading: false,
                datosParcelas: null,
                datos_de_compradores: Object.values(this.datos_compradores),
                parcelasCompradas: [],
                abonosComprados: [],
                compraFinalizada: false,
            }
        },
        methods: {
            finalizarPasoUno(zona) {
                this.zona = zona;
            },
            cambiarZona() {
                this.zona = null;
                this.datosParcelas = null;
            },
            rellenarDatosParcelas(datos) {
                this.datosParcelas = datos;
                this.parcelasCompradas = datos;
                this.abonosComprados = this.datos_de_compradores.map(abono => ({
                    ...abono,
                    parcelasAsignadas: [],
                    region: this.zona.nombre,
                    cart_id_parcelas: null
                }));
                if (this.abonosComprados.length === 1) {
                    this.abonosComprados[0].parcelasAsignadas = [...this.parcelasCompradas];
                }
                setTimeout(() => {
                    this.$scrollTo('#asignar-parcelas', 500);
                }, 500);
            },
            customLabelParcela(option) {
                return `Parcela Nº ${option.numero} - ${this.$n(option.precioSeleccionado?.precio || 0, "currency")}`;
            },
            parcelasDisponiblesParaAbono(abonoActual) {
                const asignadasAotros = this.abonosComprados
                    .filter(a => a !== abonoActual)
                    .flatMap(a => a.parcelasAsignadas)
                    .map(p => p.id);
        
                return this.parcelasCompradas.filter(p => !asignadasAotros.includes(p.id));
            },
            todasParcelasAsignadas() {
                const totalParcelasAsignadas = this.abonosComprados.reduce((total, abono) => total + abono.parcelasAsignadas.length, 0);
                return totalParcelasAsignadas === this.parcelasCompradas.length;
            },
            finalizarCompra() {
                const sessionData = this.session_butaca_data;
                const sesionIds = sessionData ? sessionData.map(sesion => sesion.id) : [];
            
                const params = {
                    lista_id: this.lista.id,
                    session_id: this.session_id,
                    abonados: this.abonosComprados.map((abono, index) => ({
                        lista_abonado_session_id: sesionIds[index],
                        parcelas: abono.parcelasAsignadas.map(parcela => ({
                            id: parcela.id,
                            precio_id: parcela.precioSeleccionado.id
                        }))
                    })),
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.bloquear-parcelas'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.compraFinalizada = true;

                    this.abonosComprados.forEach((abono, index) => {
                        this.datos_de_compradores[index].parcelasAsignadas = abono.parcelasAsignadas;
                        this.datos_de_compradores[index].region = abono.region;
                        this.datos_de_compradores[index].cart_id_parcelas = res.data.cart_ids[index];
                    });
        
                    this.$emit('finalizarCompraParcelas');
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                    this.$refs.VentaPasoDos.getParcelas();
                    console.error(error);
                });
            }
        },
        computed: {
            lista() {
                return this.$store.getters.getListaAbonados;
            },
            steps() {
                return [
                    { label: this.$t('parcelas.selecciona_region'), slot: 'pasoZona' },
                    { label: this.$t('parcelas.selecciona_parcelas'), slot: 'pasoParcelas' },
                ]
            }
        },
        components: {
            PasoUno, PasoDos, Stepper
        },
    }
</script>
